<template>
  <div>
    <InfiniteScrollSeriesCellList
      v-if="cellList && cellList.length"
      :key="'infinite-scroll_movie-series_' + $route.fullPath"
      :content-info="contentInfo"
      :cell-list="cellList"
      :thumbnail-info="thumbnailInfo"
      section="movie"
      @load-more="loadMore"
    />
  </div>
</template>

<script>
import { get } from 'lodash'
import { mapMutations } from 'vuex'
// import InfiniteScrollCellList from '@/components/section/template/cell/InfiniteScrollCellList'
import InfiniteScrollSeriesCellList from '@/components/section/template/cell/InfiniteScrollSeriesCellList'
import { getBandTypeInfoByCellType } from '@/common/image.util'
import { getMovieSeriesContents } from '@/common/utils/request'

export default {
  name: 'MovieSeriesContentList',
  components: {
    // InfiniteScrollCellList,
    InfiniteScrollSeriesCellList
  },
  props: {
    contentInfo: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      isEmptyList: true,
      thumbnailInfo: {},
      endOfList: false,
      offset: 0,
      limit: 20,
      cellList: []
    }
  },
  created () {
    this.setData()
  },
  methods: {
    ...mapMutations(['showLoadingProgress', 'hideLoadingProgress']),
    setData () {
      this.showLoadingProgress()

      const movieID = get(this.contentInfo, 'movieid', '')
      getMovieSeriesContents({ movieid: movieID }).then(({ data }) => {
        this.hideLoadingProgress()
        if (this.offset === 0) {
          this.thumbnailInfo = getBandTypeInfoByCellType('band_10')
        }
        let resultList = get(data, 'cell_toplist.celllist', [])
        this.endOfList = this.offset >= Number(get(data, 'cell_toplist.count', '0'))
        this.isEmptyList = resultList.length === 0
        if (this.endOfList || this.isEmptyList) return
        this.offset += this.limit
        this.cellList = this.cellList.concat(resultList)
      })
    },
    loadMore () {
      if (this.endOfList) return
      this.setData()
    }
  }
}
</script>
